import { Datagrid, List, TextField, SelectField, useNotify, SimpleList, DateField } from "react-admin";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { EmailRequestStatus } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

import React, { useState } from "react";
import ViewButton from "./components/ViewButton";
import ResendEmailButton from "./components/ResendEmailButton";
import { SentEmailsExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import CustomFilter from "features/CustomFilter";

const ListSentEmails = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const notify = useNotify();

  const [appliedFilter, setAppliedFilter] = useState(null);
  const [receiverEmail, setReceiverEmail] = useState("");

  const onSubmit = () => {
    const v = receiverEmail.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!v) {
      notify("Моля въведете имейл!", { type: "error" });
      return;
    }
    if (!emailRegex.test(v)) {
      notify("Невалиден имейл адрес!", { type: "error" });
      return;
    }
    setAppliedFilter({ receiverEmail: v });
  };

  return (
    <>
      <CustomFilter
        title="Търси по имейл"
        cardWidth={isMobile ? "100%" : "500px"}
        filters={[{ label: "Имейл", type: "text", value: receiverEmail, setValue: setReceiverEmail }]}
        buttonLabel="Покажи"
        buttonOnClick={onSubmit}
      />
      {!appliedFilter ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 3 }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи имейл за да продължиш.
            </Typography>
          </Box>
        </Paper>
      ) : (
        <List
          actions={<ExportXlsButton exporter={SentEmailsExporter} />}
          title="Изпратени имейли"
          filter={appliedFilter}
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={() => (
                <MobileListRow
                  fields={[
                    {
                      label: "Изпратен на",
                      value: (
                        <DateField
                          source="sentOn"
                          showTime
                          locales="bg-BG"
                          options={{
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          }}
                        />
                      ),
                    },
                  ]}
                />
              )}
              secondaryText={record => (
                <div>
                  <MobileListRow
                    fields={[
                      {
                        label: "Статус",
                        value: (
                          <SelectField
                            source="status"
                            choices={EmailRequestStatus}
                            emptyText="-"
                          />
                        ),
                      },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Темплейт",
                        value: (
                          <TextField
                            source="template"
                            emptyText="-"
                          />
                        ),
                      },
                    ]}
                  />
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    <SecuredComponent permission={permissions.canPreviewSentEmailsHistory}>
                      <ViewButton label="" />
                    </SecuredComponent>
                    <SecuredComponent permission={permissions.canResendEmails}>
                      <ResendEmailButton />
                    </SecuredComponent>
                  </div>
                </div>
              )}
            />
          ) : (
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
            >
              <DateField
                label="Изпратен на"
                source="sentOn"
                showTime
                locales="bg-BG"
                options={{ day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }}
              />

              <SelectField
                label="Статус"
                source="status"
                choices={EmailRequestStatus}
                sortable={false}
                emptyText="-"
              />
              <TextField
                label="Темплейт"
                source="template"
                sortable={false}
                emptyText="-"
              />
              <SecuredComponent permission={permissions.canPreviewSentEmailsHistory}>
                <ViewButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canResendSentEmail}>
                <ResendEmailButton />
              </SecuredComponent>
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListSentEmails;
